import React from 'react';
import { TResponsiveTableCellRendererProps } from '../types';

const DefaultCellRenderer = React.forwardRef<
  HTMLTableCellElement,
  TResponsiveTableCellRendererProps
>(
  (
    {
      cell: { Renderer, rendererProps, AccordionRenderer, ...cell },
      column,
      row,
      ...props
    },
    currentRef,
  ) => (
    <td
      ref={currentRef as React.RefObject<HTMLTableCellElement>}
      {...props}
      {...cell}
    />
  ),
);
export default DefaultCellRenderer;
